import { render, staticRenderFns } from "./BaseDialogActions.vue?vue&type=template&id=06de104a&"
import script from "./BaseDialogActions.vue?vue&type=script&lang=js&"
export * from "./BaseDialogActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports